import { useMutation } from "react-query";
import { CancelFleetPremiumParams, deleteFleetPremium } from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const deleteFleetPremiumFn = async (params: CancelFleetPremiumParams) => {
  return await deleteFleetPremium(params);
};

export function useDeleteFleetPremium() {
  return useMutation(deleteFleetPremiumFn, {
    mutationKey: MUTATION_KEYS.deleteFleetPremium,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
